import './edit-level.scss';
import { FaChevronLeft } from "react-icons/fa6";
import { FormProvider } from "react-hook-form";
import { ConfirmDialog } from "primereact/confirmdialog";

import SkeletonList from "@shared/ui/skeleton-list/skeleton-list";
import ErrorSection from "@shared/ui/error-section/error-section";
import HeaderContent from "@shared/ui/header-content/header-content";
import HeaderButton from "@shared/ui/header-button/header-button";

import FormLevel from "../form-level/form-level";
import { useEditLevel } from "./edit-level.hook";

export function EditLevel() {
  const {
    levelData,
    isLoading,
    levelError,
    formMethod,
    actions,
    handleBack,
    handleAction,
  } = useEditLevel();

  const title =
    levelData?.name ? <h1>{ levelData?.name }</h1> : <h1>Edit Level</h1>;
  const displayLoading = (
    <div className="card">
      <SkeletonList count={4} />
    </div>
  );
  const displayError = (
    <div className="card">
      <ErrorSection
        title="No Data"
        message="No data found in selected record. Please try again."
      />
    </div>
  );
  const mainContent = (
    <div>
      <section className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-4">
        <FormLevel />
      </section>
    </div>
  );

  return (
    <div id="EditLevel" className="level">
      <HeaderContent
        title={title}
        backIcon={<FaChevronLeft />}
        onBack={() => handleBack()}
      >
        <HeaderButton actions={actions} onAction={handleAction} />
      </HeaderContent>
      
      <section className="p-7">
        <ConfirmDialog />
        <FormProvider {...formMethod}>
          {isLoading && displayLoading}
          { levelError && !isLoading && displayError }
          {!isLoading ? mainContent : null}
         </FormProvider>
      </section>
    </div>
  );
}

export default EditLevel;